<template>
    <!-- Hero Section -->
    <section class="hero-section-nine">
			<div class="container">
				<div class="home-banner home-banner-nine">
					<div class="row align-items-center w-100">
						<div class="col-lg-6">

							<div class="banner-imgs banner-imgs-nine">
								<div class="row">
									<div class="col-sm-6">
										<div class="banner-img-01">
											<div class="banner-1 shape-1">
												<img class="img-fluid" alt="banner" src="@/assets/img/banner-img-04.jpg">
											</div>
											<div class="banners-3 shape-3">
												<img class="img-fluid" alt="banner" src="@/assets/img/banner-img-02.jpg">
											</div>
										</div>
									</div>
									<div class="col-sm-6">
										<div class="banner-img-02">
											<div class="banner-2 shape-3">
												<img class="img-fluid" alt="banner" src="@/assets/img/banner-img-03.jpg">
											</div>
											<div class="banner-4 shape-2">
												<img class="img-responsive" alt="banner" src="@/assets/img/banner-img-01.jpg">
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-lg-6 col-md-10 mx-auto">
							<div class="section-search section-search-nine aos" data-aos="fade-up">
								<span class="badge badge-primary-transparent">Welcome to TruelySell Mechanic</span>
								<h1 class="display-5">Providing A Professional Reliable service</h1>
								<p>Our professional cleaning service comes up with a complete solution that makes your
									space sparkle!</p>
								<router-link to="/booking/booking" class="btn btn-dark"><i class="feather-lock me-2"></i>Book Appointment</router-link>
								<div class="banner-appointment">
									<img src="@/assets/img/profiles/avatar-15.jpg" alt="User">
									<div>
										<p class="mb-1">Got a question about our service?</p>
										<h4>Call us: 092837644</h4>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
    <!-- /Hero Section -->


    <!-- Safety is out first Priority -->
    <section class="safety-section section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-12">
                    <div class="safety-first-all aos" data-aos="fade-up">
                        <div class="section-heading section-heading-nine safety-heading-nine mb-2 aos"
                            data-aos="fade-up">
                            <h2 class="display-5 mb-0">Safety is Out first Priority For <span>Us</span></h2>
                        </div>
                        <p class="safety-para">We stay ahead of industry trends and continuously seek innovative solutions to better serve our clients. </p>
                        <p>Our forward-thinking approach ensures that you benefit from the latest advancements and strategies.We operate with the highest level of integrity and ethical standards. Our business practices are designed to build long-term relationships based on trust, respect, and mutual success. If you are going to use a passage of Lorem Ipsum,</p>
                        <p>We adhere to rigorous quality standards to ensure that every service we provide meets the highest levels of excellence. Our commitment to quality is reflected in the results we deliver and the satisfaction of our clients.Our team consists of highly qualified professionals who are experts in their fields. We conduct thorough vetting and ongoing training to ensure that our team remains at the forefront of industry trends and best practices.</p>
                    </div>
                </div>
                <div class="col-lg-6 col-12">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="safety-list aos" data-aos="fade-up">
                                <img src="@/assets/img/blog/blog-13.jpg" alt="image" class="img-fluid">
                                <ul>
                                    <li>
                                        <span><i class="feather-check"></i></span>
                                        Highly Professional Staff
                                    </li>
                                    <li>
                                        <span><i class="feather-check"></i></span>
                                        100% Satisfaction Guarantee
                                    </li>
                                    <li>
                                        <span><i class="feather-check"></i></span>
                                        Quality Control System
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                            <div class="safety-list safety-ryt-two aos" data-aos="fade-up">
                                <img src="@/assets/img/blog/blog-12.jpg" alt="image" class="img-fluid">
                                <ul>
                                    <li>
                                        <span><i class="feather-check"></i></span>
                                        Accurate Testing Process
                                    </li>
                                    <li>
                                        <span><i class="feather-check"></i></span>
                                        Unrivalled Workmanship
                                    </li>
                                    <li>
                                        <span><i class="feather-check"></i></span>
                                        Timely Delivery
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- /Safety is out first Priority -->
</template>